export const devnetConfig = {
  tokens: {
    WETH: '0x05Aa229Aec102f78CE0E852A812a388F076Aa555',
    STONE: '0x0b48aF34f4c854F5ae1A3D587da471FeA45bAD52',
    USDC: '0x0f5D1ef48f12b6f691401bfe88c2037c690a6afe',
    USDT: '0x90118d110B07ABB82Ba8980D1c5cC96EeA810d2C',
    MANTA: '0xcA03Dc4665A8C3603cb4Fd5Ce71Af9649dC00d44',
  },
  users: {
    trader: '0x3C44CdDdB6a900fa2b585dd299e03d12FA4293BC',
    admin: '0x70997970C51812dc3A010C7d01b50e0d17dc79C8',
  },
  tokenRewards: [
    {
      address: '0xcA03Dc4665A8C3603cb4Fd5Ce71Af9649dC00d44',
      reward: 3,
    },
    {
      address: '0x05Aa229Aec102f78CE0E852A812a388F076Aa555',
      reward: 4000,
    },
    {
      address: '0x90118d110B07ABB82Ba8980D1c5cC96EeA810d2C',
      reward: 1,
    },
    {
      address: '0x0f5D1ef48f12b6f691401bfe88c2037c690a6afe',
      reward: 1,
    },
  ],
  mantaX3EventContract: '0xe6b98F104c1BEf218F3893ADab4160Dc73Eb8367',
  multicall: '0x381445710b5e73d34aF196c53A3D5cDa58EDBf7A',
} as const;
